import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'

import { unpinContent } from '../api'
import { contentKeys } from '../queryKeys'

const useUnpinContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ accountId, contentId }: { accountId: string; contentId: string }) =>
      unpinContent({ accountId, contentId }),
    {
      onError: () => {
        errorToast('Unable to unpin content.')
      },
      onSuccess: () => {
        successToast('Campaign unpinned successfully.')
      },
      onSettled: () => {
        queryClient.invalidateQueries(contentKeys.contentLibraryAll())
      },
    }
  )
}

export default useUnpinContentMutation
